import { useEffect, useLayoutEffect, useRef, useState } from "react";

// react-router-dom components
import { useLocation, NavLink, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import BIButton from "components/BIButtom/BIButton";
import reviewrequest from "assets/images/reviewrequest.svg"
import reviewRequestActive from "assets/images/reviewrequest_active.svg"
import reviewLogo from "assets/images/review-icon-dash.svg";
import business from "assets/images/business-inactive.svg";
import businessActive from "assets/images/business-active.svg";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Modal,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PrintIcon from "@mui/icons-material/Print";
import { QRCodeSVG } from "qrcode.react";
import toast from "react-hot-toast";
// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
import { useSelector } from "react-redux";
import { getUpdateBillingInfoUrl } from "services/subscription";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import logoHeader from "assets/images/home-page-images/TavloAI.png";

function Sidenav({ color, brand, brandName, routes, ...rest }) {

  const printRef = useRef();
  const [viewQrModalOpen, setViewQrModalOpen] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    p: { xs: 1, sm: 4 },
    textAlign: "center",
    py: 2,
  };
  const { requestGenericRequest } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  // const match = useRouteMatch();
  const [controller, dispatch] = useMaterialUIController();
  const [scroll, setScroll] = useState(false);

  const { getprofile } = useSelector((state) => state?.auth);
  const { commonId } = useSelector((state) => state.dashboard);

  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } =
    controller;
  const location = useLocation();
  const collapseName = location.pathname.replace("/", "");
  const [logout, setLogout] = useState(false);

  const [facebookSideNav, setFacebookSideNav] = useState(null);
  const [xSideNav, setXSideNav] = useState(null);
  const [googleSideNav, setGoogleSideNav] = useState(null);
  const [yelpSideNav, setYelpSideNav] = useState(null);
  const businessId = localStorage.getItem("common_id");
  const [dashboardSideNav, setDashboardSideNav] = useState(false);
  const [, setSidebarRoutes] = useState([]);

  const profileData = useSelector((state) => state.auth.getprofile);

  let textColor = "white";
  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);
  useLayoutEffect(() => {
    if (routes) {
      const sidebarNewRoutes = routes?.filter((route) => {
        return route.name === "Dashboard";
      });
      setSidebarRoutes(sidebarNewRoutes);
    }
  }, [routes]);
  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1199);

      setTransparentSidenav(
        dispatch,
        window.innerWidth < 1199 ? false : transparentSidenav
      );
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? true : whiteSidenav);
    }

    /**
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location, transparentSidenav, whiteSidenav]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/sign-in");
    setLogout(false);
  };


  async function onClickUpdatePaymentMethod() {

    const userId = profileData?.userProfile?.id;

    if (!userId) {
      return;
    }

    try {
      const data = await getUpdateBillingInfoUrl(userId, window.location.href);

      if (!data?.url) {
        throw new Error('Unable to get update payment method url');
      }

      window.location.href = data.url;

    } catch (err) {
      console.log(err);
    }

  }

  useEffect(() => {
    if (logout) {
      handleLogout();
    }
  }, [logout]);

  useEffect(() => {
    if (scroll) {
      if (window.location.pathname === "/dashboard") {
        const bottomOffset = 1050; // Adjust this value as needed
        window.scrollTo({
          top: document.body.scrollHeight - bottomOffset,
          behavior: "smooth",
        });
      }
      setScroll(false);
    }
  }, [scroll]);

  useEffect(() => {
    if (getprofile?.businesses?.length > 0) {
      const businessId = localStorage.getItem("common_id");
      const business = getprofile?.businesses?.find(
        (x) => x?.common_id == businessId
      );
      if (business) {
        setDashboardSideNav(true);
        setFacebookSideNav(business?.facebook_reviews_count);
        setXSideNav(business?.twitter_reviews_count);
        setGoogleSideNav(business?.google_reviews_count);
        setYelpSideNav(business?.yelp_reviews_count);
      } else {
        setDashboardSideNav(false);
      }
    } else {
      setDashboardSideNav(false);
    }
  }, [getprofile, commonId]);



  const handleViewQrCode = () => {
    setViewQrModalOpen(true);

  };
  const handlePrint = () => {
    const printContent = document.getElementById("print-section").innerHTML;
    const WinPrint = window.open('', '', 'width=600,height=800');
    WinPrint.document.write(`
<html>
  <head>
    <title>Print QR Code</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        text-align: center;
        margin: 0;
        padding: 20px;
      }
      h2 {
        font-size: 24px;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 8px;
      }
      h3 {
        font-size: 18px;
        font-weight: bold;
        margin-top: 0;
        margin-bottom: 20px;
      }
      svg {
        width: 350 !important;
        height: 350 !important;
      }
    </style>
  </head>
  <body>
    ${printContent}
  </body>
</html>
`);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  const linkToCopy = `${window.location.host}/redirect-generic?link=${requestGenericRequest?.review_request_generic?.link}`;
  const restaurantName = requestGenericRequest?.business?.restaurant_name || '';
  const bussinessAddress = requestGenericRequest?.business?.business_address || '';

  return (
    <>
      {collapseName == "chatbot" ? (
        ""
      ) : (
        <SidenavRoot
          className="dashboard-sidenav"
          {...rest}
          variant="permanent"
          ownerState={{
            transparentSidenav,
            whiteSidenav,
            miniSidenav,
            darkMode,
          }}
        >
          <MDBox
            pt={3}
            pb={1}
            px={4}
            textAlign="center"
            className="customchangez-index"
          >
            <MDBox
              display={{ xs: "block", xl: "none" }}
              position="absolute"
              top={0}
              right={0}
              p={1.625}
              onClick={closeSidenav}
              sx={{ cursor: "pointer" }}
            >
              <MDTypography variant="h6" color="secondary">
                <Icon sx={{ fontWeight: "bold" }}>close</Icon>
              </MDTypography>
            </MDBox>
            {getprofile?.businesses?.length > 0 ? (
              <MDBox
                component={NavLink}
                to="/dashboard"
                display="flex"
                alignItems="center"
              >
                {brand && (
                  <MDBox component="img" src={logoHeader} alt="Brand" width="9rem" />
                )}
                <MDBox
                  width={!brandName && "100%"}
                  sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
                >
                  <MDTypography
                    component="h6"
                    variant="button"
                    fontWeight="medium"
                    color={textColor}
                  >
                    {brandName}
                  </MDTypography>
                </MDBox>
              </MDBox>
            ) : (
              <MDBox
                display="flex"
                alignItems="center"
                component={NavLink}
                to="/"
              >
                {brand && (
                  <MDBox component="img" src={brand} alt="Brand" width="9rem" />
                )}
                <MDBox
                  width={!brandName && "100%"}
                  sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
                >
                  <MDTypography
                    component="h6"
                    variant="button"
                    fontWeight="medium"
                    color={textColor}
                  >
                    {brandName}
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}
          </MDBox>
          <Divider
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
          {/* <List>{renderRoutes}</List> */}
          <List sx={{ height: "100%" }}>
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <MDBox height="100%">
                <Box sx={{ height: '100%', display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>


                    {dashboardSideNav && (
                      <>
                        <NavLink
                          style={{
                            position:
                              collapseName === "dashboard"
                                ? "relative"
                                : "static",
                          }}
                          to={"/dashboard"}
                        >
                          <SidenavCollapse
                            name={"Dashboard"}
                            icon={<Icon fontSize="small">dashboard</Icon>}
                            active={"dashboard" === collapseName}
                          />
                          {collapseName === "dashboard" && (
                            <MDBox
                              sx={{
                                width: "4px",
                                height: "32px",
                                borderRadius: "25px",
                                backgroundColor: "#318BEC",
                                position: "absolute",
                                right: 0,
                                top: "8px",
                              }}
                            ></MDBox>
                          )}
                        </NavLink>

                        <NavLink
                          style={{
                            position:
                              collapseName === "dashboard"
                                ? "relative"
                                : "static",
                          }}
                          to={"/dashboard"}
                          onClick={() => setScroll(true)}
                        >
                          <SidenavCollapse
                            name={"Review"}
                            icon={<img src={reviewLogo}></img>}
                            active={"review" === collapseName}
                          />
                        </NavLink>
                      </>
                    )}
                    {dashboardSideNav && googleSideNav && (
                      <NavLink
                        style={{
                          position:
                            collapseName === "google-dashboard"
                              ? "relative"
                              : "static",
                        }}
                        to={"/google-dashboard"}
                      >
                        <SidenavCollapse
                          name={"Google"}
                          active={"google-dashboard" === collapseName}
                        />
                        {collapseName === "google-dashboard" && (
                          <MDBox
                            sx={{
                              width: "4px",
                              height: "32px",
                              borderRadius: "25px",
                              backgroundColor: "#318BEC",
                              position: "absolute",
                              right: 0,
                              top: "8px",
                            }}
                          ></MDBox>
                        )}
                      </NavLink>
                    )}
                    {dashboardSideNav && yelpSideNav && (
                      <NavLink
                        style={{
                          position:
                            collapseName === "yelp-dashboard"
                              ? "relative"
                              : "static",
                        }}
                        to={"/yelp-dashboard"}
                      >
                        <SidenavCollapse
                          name={"Yelp"}
                          active={"yelp-dashboard" === collapseName}
                        />
                        {collapseName === "yelp-dashboard" && (
                          <MDBox
                            sx={{
                              width: "4px",
                              height: "32px",
                              borderRadius: "25px",
                              backgroundColor: "#318BEC",
                              position: "absolute",
                              right: 0,
                              top: "8px",
                            }}
                          ></MDBox>
                        )}
                      </NavLink>
                    )}
                    {dashboardSideNav && facebookSideNav && (
                      <NavLink
                        style={{
                          position:
                            collapseName === "facebook-dashboard"
                              ? "relative"
                              : "static",
                        }}
                        key={"facebook"}
                        to={"/facebook-dashboard"}
                      >
                        <SidenavCollapse
                          name={"Facebook"}
                          active={"facebook-dashboard" === collapseName}
                        />
                        {collapseName === "facebook-dashboard" && (
                          <MDBox
                            sx={{
                              width: "4px",
                              height: "32px",
                              borderRadius: "25px",
                              backgroundColor: "#318BEC",
                              position: "absolute",
                              right: 0,
                              top: "8px",
                            }}
                          ></MDBox>
                        )}
                      </NavLink>
                    )}

                    {dashboardSideNav && (
                      <>
                        <NavLink
                          style={{
                            position:
                              collapseName === "My Business"
                                ? "relative"
                                : "static",
                          }}
                          to={"/my-business"}
                        >
                          <SidenavCollapse
                            name={"My Business"}
                            icon={<img src={`${collapseName === "my-business" ? businessActive : business}`} style={{ width: "22px", height: "22px" }}></img>}
                            active={"my-business" === collapseName}
                          />
                          {collapseName === "my-business" && (
                            <MDBox
                              sx={{
                                width: "4px",
                                height: "32px",
                                borderRadius: "25px",
                                backgroundColor: "#318BEC",
                                position: "absolute",
                                right: 0,
                                top: "168px",
                              }}
                            ></MDBox>
                          )}
                        </NavLink>

                        <MDBox
                          style={{
                            position:
                              collapseName === "Subscriptions"
                                ? "relative"
                                : "static",
                          }}
                          onClick={onClickUpdatePaymentMethod}
                        >
                          <SidenavCollapse
                            name={"Subscriptions"}
                            icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="20" height="20" style={{ marginRight: "8px" }}>
                              <rect x="10" y="25" width="80" height="50" rx="5" fill="#161616" />
                              <rect x="15" y="35" width="70" height="5" fill="#FFF" />
                              <rect x="15" y="45" width="40" height="5" fill="#FFF" />
                              <rect x="60" y="15" width="30" height="60" rx="3" fill="#262626" />
                              <line x1="65" y1="25" x2="85" y2="25" stroke="#fff" strokeWidth="2" />
                              <line x1="65" y1="35" x2="85" y2="35" stroke="#fff" strokeWidth="2" />
                              <line x1="65" y1="45" x2="85" y2="45" stroke="#fff" strokeWidth="2" />
                              <path d="M65,70 L70,65 L75,70 L80,65 L85,70" fill="none" stroke="#000" strokeWidth="2" />
                            </svg>}
                            active={"subscriptions" === collapseName}
                          />
                          {collapseName === "subscriptions" && (
                            <MDBox
                              sx={{
                                width: "4px",
                                height: "32px",
                                borderRadius: "25px",
                                backgroundColor: "#318BEC",
                                position: "absolute",
                                right: 0,
                                top: "8px",
                              }}
                            ></MDBox>
                          )}
                        </MDBox>
                        {/* <NavLink
                          style={{
                            position:
                              collapseName === "Request Review"
                                ? "relative"
                                : "static",
                          }}
                          to={"/request-reviews"}
                        >
                          <SidenavCollapse
                            name={"Request Review"}
                            icon={<img src={`${collapseName === "request-reviews" ? reviewRequestActive : reviewrequest}`} style={{ width: "22px", height: "22px" }}></img>}
                            active={"request-reviews" === collapseName}
                          />
                          {collapseName === "request-reviews" && (
                            <MDBox
                              sx={{
                                width: "4px",
                                height: "32px",
                                borderRadius: "25px",
                                backgroundColor: "#318BEC",
                                position: "absolute",
                                right: 0,
                                top: "168px",
                              }}
                            ></MDBox>
                          )}

                        </NavLink> */}

                         <NavLink
                          style={{
                            position:
                              collapseName === "Request Review "
                                ? "relative"
                                : "static",
                          }}
                          to={"/request-reviews"}
                        >
                          <SidenavCollapse
                            name={"Request Review"}
                            icon={<img src={`${collapseName === "request-reviews" ? reviewRequestActive : reviewrequest}`} style={{ width: "22px", height: "22px" }}></img>}
                            active={"request-reviews" === collapseName}
                          />
                          {collapseName === "request-reviews" && (
                            <MDBox
                              sx={{
                                width: "4px",
                                height: "32px",
                                borderRadius: "25px",
                                backgroundColor: "#318BEC",
                                position: "absolute",
                                right: 0,
                                top: "168px",
                              }}
                            ></MDBox>
                          )}

                        </NavLink>

                        <Button
                          variant="outlined"
                          startIcon={<QrCode2Icon />}
                          onClick={handleViewQrCode}
                          sx={{
                            width: '55%',
                            // height: '48px',
                            ml: '85px',
                            mt: 1,
                            borderRadius: '12px',
                            border: '1.5px solid #318BEC',
                            color: '#318BEC',
                            textTransform: 'none',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: '13px',
                            fontWeight: 900,                            
                            '& .MuiButton-startIcon': {
                              marginRight: '2px',
                            },
                            '&:hover': {
                              backgroundColor: '#E6F0FB',
                              boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
          
                              border: '2px solid #318BEC',
                            },
                          }}
                        >
                          View QR Code
                        </Button>






                      </>
                    )}
                  </Box>
                  <Box>
                    <BIButton />
                  </Box>
                  {/* {dashboardSideNav && xSideNav && (
                    <NavLink
                      style={{
                        position:
                          collapseName === "x-dashboard"
                            ? "relative"
                            : "static",
                      }}
                      key={"x"}
                      to={"/x-dashboard"}
                    >
                      <SidenavCollapse
                        name={"X"}
                        active={"x-dashboard" === collapseName}
                      />
                      {collapseName === "x-dashboard" && (
                        <MDBox
                          sx={{
                            width: "4px",
                            height: "32px",
                            borderRadius: "25px",
                            backgroundColor: "#318BEC",
                            position: "absolute",
                            right: 0,
                            top: "8px",
                          }}
                        ></MDBox>
                      )}
                    </NavLink>
                  )} */}
                </Box>
              </MDBox>
            </MDBox>
          </List>
        </SidenavRoot>
      )}
      <Modal open={viewQrModalOpen}>
        <Box sx={style} position="relative" ref={printRef}>
          <IconButton
            onClick={() => setViewQrModalOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontSize: "20px" }} >
            Scan QR code
          </Typography>
          <Typography
            variant="h6"
            py={1}
            sx={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "0px", textTransform: "uppercase" }}
          >
            {restaurantName}
          </Typography>
          <Typography
            variant="body1"

            sx={{ fontSize: "16px", fontWeight: "bold", paddingBottom: "20px" }}
          >
            {bussinessAddress}
          </Typography>
          <QRCodeSVG value={linkToCopy} width={250} height={250} />
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} gap={2} mt={2}>
            <Button variant="contained" sx={{ color: "#fff", fontSize: "15px" }} onClick={() => setViewQrModalOpen(false)}>
              Close
            </Button>
            <Button
              variant="contained"
              sx={{ display: "flex", alignItems: "center", gap: 1, color: "#fff", fontSize: "15px" }}

              onClick={() => {
                navigator.clipboard.writeText(linkToCopy);
                toast.success("Link Copied Successfully");
              }}
            >
              <ContentCopyIcon sx={{ fontSize: "20px" }} />
              Copy
            </Button>
            <Button
              variant="contained"
              sx={{ display: "flex", alignItems: "center", gap: 1, color: "#fff", fontSize: "15px" }}
              onClick={handlePrint}
            >
              <PrintIcon sx={{ fontSize: "20px" }} />
              Print
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
